import './BrandsActions.css';
import { BrandsActionsProps } from './BrandsActions.types';

/**
 * Renders action buttons for brands management
 * Provides save and export functionality with permission-based visibility
 *
 * @param props - Component props
 * @returns JSX element containing action buttons
 */
export function BrandsActions({ canCreate, canExport, hasChanges, onSave, onExport }: BrandsActionsProps): JSX.Element {
  return (
    <div className="brands-action-controls">
      {canCreate && (
        <button onClick={onSave} disabled={!hasChanges} className="brands-save-btn">
          Зберегти зміни в брендах
        </button>
      )}
      {canExport && (
        <button onClick={onExport} className="brands-export-btn">
          Вивантажити в Excel
        </button>
      )}
    </div>
  );
}
